export const SWITCH_TEST_ID = "switch-test-id";
export const SWITCH_TOGGLING_ANIMATION_DURATION = 300;
